module.exports = __webpack_public_path__ + "img/apply.2c3a15fb.png";